// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {noop, get, isEmpty, isEqual} from 'lodash';

// Redux Actions
import {setFieldValue} from '../actions/form-data-actions';

// Contexts
import {FormContext} from '../contexts/form-context';

// Config
import getBootstrapInitialState from '../bootstrap-data/forms-initial-states';

function FormContextProvider({children, formName, setFieldValue, formData}) {
    const getFormInitialState = () => {
        return getBootstrapInitialState(formName);
    };

    const getCurrentFormData = () => {
        return get(formData, formName, {});
    };

    const isFormValid = () => {
        const currentFormData = getCurrentFormData();
        const initialState = getFormInitialState();

        // Check if there are any field errors
        const fieldErrors = get(currentFormData, 'fieldErrors', {});
        const hasErrors = !isEmpty(fieldErrors) && Object.values(fieldErrors).some(errors => !isEmpty(errors));

        if (hasErrors) {
            return false;
        }

        // Check if form has been modified (dirty state)
        const currentValues = get(currentFormData, 'values', {});
        const initialValues = get(initialState, 'values', {});
        const hasChanges = !isEqual(currentValues, initialValues);

        // Form is valid if it has changes and no errors
        return hasChanges;
    };

    return (
        <FormContext.Provider
            value={{
                formName,
                isFormValid,
                onSubmit: noop,
                setFieldErrors: noop,
                setFieldValue: (fieldName, value) => setFieldValue(formName, fieldName, value),
                unregisterFieldErrors: noop,
                unregisterFieldValue: noop,
            }}
        >
            {children}
        </FormContext.Provider>
    );
}

FormContextProvider.propTypes = {
    children: PropTypes.node,
    formData: PropTypes.object.isRequired,
    formName: PropTypes.string.isRequired,
    setFieldValue: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    formData: state.formData,
});

const mapDispatchToProps = {
    setFieldValue,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormContextProvider);
